import { ExportData } from "./LanguageTableHelper";

//Преобразование Related Fields для просмотра
export function showRelatedFields(relatedFields) {
    let keys = Object.keys(relatedFields);
    let str = keys.join(',');
    return str
}

//Преобразование Related Fields для сохранения
export function parseRelatedFields(inputString) {
    let fieldstoset = inputString.split(/[\s,]+/);
    let relatedFieldsWait = {};

    fieldstoset.forEach((value, key) => {
        // Пример: ключ "field1" будет добавлен как свойство "field1: (key + 1)"
        relatedFieldsWait[value] = key + 1;
    });

    return relatedFieldsWait;
}

//Преобразование поля playtext для просмотра
export function playtexttostring(LANGPLAYTEXTARRAY = [''], label = '') {
    // Если старый вариант массива - то по умолчанию ru
    let firstKey = Object.keys(LANGPLAYTEXTARRAY)[0];
    if (firstKey !== undefined && !isNaN(firstKey)) {
        LANGPLAYTEXTARRAY = { 'ru': LANGPLAYTEXTARRAY };
    }

    // Разбор массива с языком
    let fullresult = '';
    for (let lang in LANGPLAYTEXTARRAY) {
        let PLAYTEXTARRAY = LANGPLAYTEXTARRAY[lang];
        let result = '';
        PLAYTEXTARRAY.forEach((OPTION, index) => {
            if (result !== '') result = result + '|';
            if (Array.isArray(OPTION)) {
                OPTION.forEach((PART, partkey) => {
                    let separator = '';
                    if (PART.text.charAt(0) === '#') {
                        separator = '#';
                        PART.text = PART.text.substring(1);
                    } else {
                        separator = (partkey === 0) ? '' : '&';
                    }
                    if (PART.conversationtemplatecode !== '') {
                        PART.conversationtemplatecode = PART.conversationtemplatecode + '/';
                    }
                    PART.pitchoverride = PART.pitchoverride || '';
                    if (PART.pitchoverride !== '') PART.pitchoverride = '<p' + PART.pitchoverride + '>';
                    PART.tempooverride = PART.tempooverride || '';
                    if (PART.tempooverride !== '') PART.tempooverride = '<t' + PART.tempooverride + '>';

                    result = result + separator + PART.conversationtemplatecode + PART.pitchoverride + PART.tempooverride + PART.text;
                });
            } else {
                result = result + OPTION;
            }
        });
        if (fullresult !== '') fullresult = fullresult + '\n';
        fullresult = fullresult + label + lang + ':' + result;
    }
    return fullresult;
}

export function playtexttoarray(playtextstring) {
    playtextstring = playtextstring.trim();
    if (playtextstring === '') return {};

    const result = {};

    // Разделяем по языковым меткам (например, ru:..., en:...)
    const langBlocks = playtextstring.match(/([a-z]{2}):(.*?)(?=([a-z]{2}):|$)/gsi);

    if (!langBlocks) return {};

    langBlocks.forEach(block => {
        const match = block.match(/^([a-z]{2}):(.*)$/si);
        if (!match) return;

        const lang = match[1].trim();
        const content = match[2].trim();

        const ARRAY = content.split("|").map(optionstring => {
            let OPTIONARRAY = [];
            optionstring = optionstring.trim();
            if (optionstring === '') return OPTIONARRAY;

            let PARTSARRAY = optionstring.split(/([&|#])/).filter(parttext => parttext.trim() !== '');
            let lastdelimeter;

            PARTSARRAY.forEach(parttext => {
                parttext = parttext.trim();
                if (parttext === '&' || parttext === '#') {
                    lastdelimeter = parttext;
                    return;
                }

                let pitchoverride = '';
                let pitchMatches = parttext.match(/(?<=<p)(.*?)(?=>)/);
                if (pitchMatches) {
                    pitchoverride = pitchMatches[1];
                    if (isNaN(pitchoverride)) pitchoverride = '';
                }

                let tempooverride = '';
                let tempoMatches = parttext.match(/(?<=<t)(.*?)(?=>)/);
                if (tempoMatches) {
                    tempooverride = tempoMatches[1];
                    if (isNaN(tempooverride)) tempooverride = '';
                }

                parttext = parttext.replace(/<(.*?)>/g, '');

                let conversationtemplatecode = '';
                let templateseparatorpos = parttext.indexOf('/');
                if (templateseparatorpos !== -1) {
                    conversationtemplatecode = parttext.substring(0, templateseparatorpos).trim();
                    parttext = parttext.substring(templateseparatorpos + 1).trim();
                }

                if (parttext === '') return;
                if (lastdelimeter === '#') parttext = '#' + parttext;

                OPTIONARRAY.push({
                    'conversationtemplatecode': conversationtemplatecode,
                    'text': parttext,
                    'pitchoverride': pitchoverride,
                    'tempooverride': tempooverride
                });
            });

            return OPTIONARRAY;
        });

        result[lang] = ARRAY;
    });

    return result;
}


//Преобразования для просмотра поля FieldsToSet
export function showFieldsToSet(obj) {
    let str = '';
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            str = str + key + ',';
        }
    }
    str = str.slice(0, -1);
    return str
}

//Преобразование Related Fields для сохранения
export function parseFieldsToSet(inputString) {
    let fieldstoset = inputString.split(/[\s,]+/);
    let fields = {};

    fieldstoset.forEach((value, key) => {
        // Пример: ключ "field1" будет добавлен как свойство "field1: (key + 1)"
        fields[value] = key + 1;
    });

    return fields;
}

//Преобразование Required Fields для сохранения
export function parseRequiredFields(inputString) {
    let fieldstoset = inputString.split(/[\s,]+/);
    let fields = {};

    fieldstoset.forEach((value, key) => {
        // Пример: ключ "field1" будет добавлен как свойство "field1: 1"
        fields[value] = 1;
    });

    return fields;
}


export function processPreprocessInput(preprocessinput, preprocessinputassertionnegation) {
    console.log(preprocessinput);
    if (preprocessinput !== undefined && preprocessinput[0][0][0] !== '' && preprocessinput[0][0][1] !== '1' && preprocessinputassertionnegation !== undefined) {
        console.log(preprocessinput);
        console.log(preprocessinputassertionnegation);
        let result = '';

        preprocessinput.forEach((row, key) => {
            row.forEach(([value, isOne], subkey) => {
                if (isOne === 1) {
                    if (subkey !== 0) result += '+';
                    result += value;
                } else {
                    result += '-' + value;
                }
            });

            if (preprocessinputassertionnegation[key] && preprocessinputassertionnegation[key].assertion !== undefined) {
                result += '=' + preprocessinputassertionnegation[key].assertion;
            }
            if (preprocessinputassertionnegation[key] && preprocessinputassertionnegation[key].negation !== undefined) {
                result += '|' + preprocessinputassertionnegation[key].negation;
            }
            if (preprocessinputassertionnegation[key] && preprocessinputassertionnegation[key].question !== undefined) {
                result += '|' + preprocessinputassertionnegation[key].question;
            }
            if (preprocessinputassertionnegation[key] && preprocessinputassertionnegation[key].conditional !== undefined) {
                result += '|' + preprocessinputassertionnegation[key].conditional;
            }

            if (key !== preprocessinput.length - 1) {
                result += ',';
            }
        });

        return result;
    }
    else return ''
}


export function transformLabels(labels, logicchecks, assertionnegation, priorities) {
    console.log(labels);
    const transformedLabels = [];

    for (let key in labels) {
        const label = labels[key].trim();
        let beforeSeparator = '';
        if (logicchecks !== undefined) {
            if (logicchecks[key] && logicchecks[key] !== 0) {
                beforeSeparator = '(*)';
            }

            if (priorities[key] && priorities[key] !== -1 && priorities[key] !== -2) {
                beforeSeparator = priorities[key] + beforeSeparator;
            }

            if (beforeSeparator !== '') {
                labels[key] = beforeSeparator + ':' + labels[key];
            }
        }

        if (assertionnegation !== undefined) {
            if (assertionnegation[key] && assertionnegation[key]['assertion']) {
                labels[key] = labels[key] + '=' + assertionnegation[key]['assertion'];
            }

            // Всегда добавляйте символ вертикальной черты, даже если negation - это пустая строка
            if (assertionnegation[key] && assertionnegation[key]['negation'] !== undefined) {
                labels[key] = labels[key] + '|' + assertionnegation[key]['negation'];
            }

            if (assertionnegation[key] && assertionnegation[key]['question'] !== undefined) {
                labels[key] = labels[key] + '|' + assertionnegation[key]['question'];
            }

            if (assertionnegation[key] && assertionnegation[key]['conditional'] !== undefined) {
                labels[key] = labels[key] + '|' + assertionnegation[key]['conditional'];
            }
        }

        transformedLabels.push(labels[key]);
    }

    return transformedLabels.join('\n');
}

export function transformLabelsforAnalisis(labels) {
    const transformedLabels = [];

    for (let i = 0; i < labels.length; i++) {
        const label = labels[i].trim();
        const transformedLabel = {};

        console.log(label);

        // Используем регулярное выражение для поиска приоритета в начале строки
        const priorityMatch = label.match(/^(\d+):/);

        if (priorityMatch) {
            transformedLabel.priority = parseInt(priorityMatch[1]);
            // Удаляем приоритет из строки
            label = label.replace(priorityMatch[0], '');
        }

        // По вашему примеру, разбиваем строку на части по знакам "=" и "|"
        // console.log(label);
        const parts = label.split(/=|\|/);

        console.log(parts);

        // Заполняем объект в соответствии с наличием частей
        if (parts.length > 0) {
            transformedLabel.label = parts[0].trim();
        }

        if (parts.length > 1) {
            transformedLabel.assertion = parts[1].trim();
        }

        if (parts.length > 2) {
            transformedLabel.negation = parts[2].trim();
        }

        if (parts.length > 3) {
            transformedLabel.question = parts[3].trim();
        }

        if (parts.length > 4) {
            transformedLabel.conditional = parts[4].trim();
        }

        transformedLabels.push(transformedLabel);
    }

    return transformedLabels;
}


export function formatWordsSubstr(wordssubstrings, lables) {
    let formattedString = '';

    if (wordssubstrings) {
        for (const analyzekey in wordssubstrings) {
            console.log(wordssubstrings);
            if (wordssubstrings.hasOwnProperty(analyzekey)) {
                // Добавление имени варианта
                formattedString += (lables[analyzekey] !== undefined ? lables[analyzekey] : '!!!') + ':';

                wordssubstrings[analyzekey].forEach((row, key) => {
                    row.forEach((value, subkey) => {
                        if (value[1] === 1) {
                            if (subkey !== 0) {
                                formattedString += '+';
                            }
                            formattedString += value[0];
                        } else {
                            formattedString += '-' + value[0];
                        }
                    });

                    if (key !== wordssubstrings[analyzekey].length - 1) {
                        formattedString += ',';
                    }
                });

                if (analyzekey !== Object.keys(wordssubstrings).slice(-1)[0]) {
                    formattedString += '\n';
                }
            }
        }
    }
    return formattedString
}

export function formatContext(context, labels) {
    let formattedString = '';
    console.log(context);
    if (context) {
        Object.keys(context).forEach((key, index) => {
            // Добавление имени варианта
            if (labels[key]) {
                formattedString += labels[key] + ':';
            } else {
                formattedString += '!!!:';
            }

            formattedString += context[key];

            if (index !== Object.keys(context).length - 1) {
                formattedString += '\n';
            }
        });
    }

    return formattedString;
}

export function playtextToFormattedString(playtexts, labels) {
    let formattedString = '';

    if (playtexts) {

        for (const key in playtexts) {
            if (playtexts.hasOwnProperty(key)) {
                // Добавление имени варианта
                formattedString += labels[key] ? labels[key] + ':' : '!!!:';

                if (Array.isArray(playtexts[key])) {
                    formattedString += playtexttostring(playtexts[key]);
                } else {
                    formattedString += playtexts[key];
                }

                if (key !== Object.keys(playtexts).pop()) {
                    formattedString += '\n';
                }
            }
        }
    }

    return formattedString;
}

export function formatDirtyFields(dirtyFields, labels) {
    let formattedText = '';

    if (dirtyFields && Object.keys(dirtyFields).length > 0) {
        Object.keys(dirtyFields).forEach((key, index) => {
            let label = labels[key] ? labels[key] + ':' : '!!!:';
            formattedText += label + dirtyFields[key].join(',');

            if (index < Object.keys(dirtyFields).length - 1) {
                formattedText += '\n';
            }
        });
    }

    return formattedText;
}

// Преобразование setfields в строку для редактирования
export function formatSetFields(setFields) {
    let formattedText = '';

    if (setFields != undefined && Object.keys(setFields).length > 0) {

        let analyzeRow = setFields;

        analyzeRow.forEach((row, fieldIndex) => {
            let name = row.fieldname;
            if (name !== '' && name != undefined) {
                let value = row.fieldvalue;
                if (row.fieldcorrect !== 1) value = '(-)' + value;
                formattedText += name + '=' + value;
            }

            if (fieldIndex < analyzeRow.length - 1) {
                formattedText += ',';
            }
        });

    }

    return formattedText;
}
// Преобразование setfields в массив для записи
export function parseSetFields(formattedText) {
    let resultArray = [];

    if (formattedText != '') {
        let fieldPairs = formattedText.split(',');

        fieldPairs.forEach(pair => {
            let [name, value] = pair.split('=');
            name = name.trim();
            value = value.trim();

            let fieldcorrect = 1;
            if (value.startsWith('(-)')) {
                fieldcorrect = 0;
                value = value.substring(3).trim();
            }

            resultArray.push({
                "fieldname": name,
                "fieldvalue": `${value}`,
                "fieldcorrect": fieldcorrect
            });
        });
    }

    return resultArray;
}



export function formatTerminatePlayText(terminatePlayText) {
    if (terminatePlayText) {
        if (Array.isArray(terminatePlayText)) {
            return playtexttostring(terminatePlayText);
        } else {
            return terminatePlayText;
        }
    }
    return '';
}

export function formatDirtyFieldsNoLables(dirtyfields) {
    if (dirtyfields && typeof dirtyfields === 'object') {
        const keys = Object.keys(dirtyfields);
        return keys.join(',');
    } else {
        return '';
    }
}

export function arrayToObjectWithIndexes(inputArray, convertType = 'object') {
    const resultObject = {};

    for (let i = 0; i < inputArray.length; i++) {
        const element = inputArray[i];

        // Проверка на пустой объект
        if (convertType == 'object') {
            if (Object.keys(element).length !== 0) {
                resultObject[i] = element;
            }
        }
        else if (convertType == 'string') {
            if (element.length !== 0) {
                resultObject[i] = element;
            }
        }
        else if (convertType == 'dirtyfields') {
            if (element.length !== 0) {
                resultObject[i] = element.split(',');
            }
        }
        else if (convertType == 'playtext') {
            if (element.length !== 0) {
                resultObject[i] = playtexttoarray(element);
            }
        }
        else if (convertType == 'setfields') {
            if (element.length !== 0) {
                resultObject[i] = parseSetFields(element);
            }
        }

    }

    return resultObject;
}


export function saveCommand(data) {
    if (data.command) {
        if (data.command === "analyzefreeinput") {
            return {
                ...data,
                commanddetails: JSON.stringify({
                    analyzefreeinput: {
                        'analyzetemplates': data.commanddetails.analyzefreeinput.analyzetemplates.split('\n'),
                        'ai_orchestration_prompts': data.commanddetails.analyzefreeinput.ai_orchestration_prompts.split('\n'),
                        'labels': data.commanddetails.analyzefreeinput.labels,
                        'wordssubstrings': data.commanddetails.analyzefreeinput.wordssubstrings.map((el) => ExportData(el)['data']),
                        'contexts': arrayToObjectWithIndexes(data.commanddetails.analyzefreeinput.contexts, 'string'),
                        'playtexts': arrayToObjectWithIndexes(data.commanddetails.analyzefreeinput.playtexts, 'playtext'),
                        'dirtyfields': arrayToObjectWithIndexes(data.commanddetails.analyzefreeinput.dirtyfields, 'dirtyfields'),
                        'setfields': arrayToObjectWithIndexes(data.commanddetails.analyzefreeinput.setfields, 'setfields'),
                        'terminatecondition': data.commanddetails.analyzefreeinput.terminatecondition,
                        'terminateplaytext': playtexttoarray(data.commanddetails.analyzefreeinput.terminateplaytext),
                        'assenttexts': playtexttoarray(data.commanddetails.analyzefreeinput.assenttexts),
                        'ai_assenttexts': playtexttoarray(data.commanddetails.analyzefreeinput.ai_assenttexts),
                        'realtimestatuscode': data.commanddetails.analyzefreeinput.realtimestatuscode,
                        'exitcode': data.commanddetails.analyzefreeinput.exitcode,
                        'priorities': data.commanddetails.analyzefreeinput.priorities,
                        'assertionnegation': arrayToObjectWithIndexes(data.commanddetails.analyzefreeinput.assertionnegation),
                        'logicchecks': data.commanddetails.analyzefreeinput.logicchecks,
                    }
                })
            }
        }
        else if (data.command === "wait") {
            return {
                ...data,
                commanddetails: JSON.stringify({
                    wait: {
                        "numberofseconds": data.commanddetails.wait.numberofseconds,
                        "waitforlastunanalyzedend": data.commanddetails.wait.waitforlastunanalyzedend,
                        'relatedfields': parseRelatedFields(data.commanddetails.wait.relatedfields),
                        "skipifrelatedfieldscorrect": data.commanddetails.wait.skipifrelatedfieldscorrect,
                    }
                })
            }
        }
        else if (data.command === "play") {
            return {
                ...data,
                commanddetails: JSON.stringify({
                    play: {
                        'relatedfields': parseRelatedFields(data.commanddetails['play'].relatedfields),
                        'playtext': playtexttoarray(data.commanddetails['play'].playtext),
                        "skipifrelatedfieldscorrect": data.commanddetails['play'].skipifrelatedfieldscorrect,
                    }
                })
            }
        }
        else if (data.command === "record") {
            return {
                ...data,
                commanddetails: JSON.stringify({
                    record: {
                        'fieldstoset': parseFieldsToSet(data.commanddetails['record'].fieldstoset),
                        'clearincorrectfields': data.commanddetails['record'].clearincorrectfields,
                        'fieldsrequired': parseRequiredFields(data.commanddetails['record'].fieldsrequired),
                        'skipifrelatedfieldscorrect': data.commanddetails['record'].skipifrelatedfieldscorrect,
                        'voiceordtmf': data.commanddetails['record'].voiceordtmf,
                        'waitfordtmffirst': data.commanddetails['record'].waitfordtmffirst,
                        'forbidearlyexit': data.commanddetails['record'].forbidearlyexit,
                        'silence': data.commanddetails['record'].silence,
                        'maxduration': data.commanddetails['record'].maxduration,
                        'dtmftimeout': data.commanddetails['record'].dtmftimeout,
                        'dtmfmaxdigits': data.commanddetails['record'].dtmfmaxdigits,
                        'errortext': playtexttoarray(data.commanddetails['record'].errortext),
                        'preprocessinputassertionnegation': ExportData(data.commanddetails['record'].preprocessinput)['wordMeans'],
                        'preprocessinput': ExportData(data.commanddetails['record'].preprocessinput)['data'],
                        'checkinput': {
                            'onlydigits': data.commanddetails['record'].checkinput.onlydigits,
                            'isphonenumber': data.commanddetails['record'].checkinput.isphonenumber,
                            'iscardnumber': data.commanddetails['record'].checkinput.iscardnumber,
                            'isdate': data.commanddetails['record'].checkinput.isdate,
                            'strictdate': data.commanddetails['record'].checkinput.strictdate,
                            'datepriority': data.commanddetails['record'].checkinput.datepriority,
                            'isaddress': data.commanddetails['record'].checkinput.isaddress,
                            'addresspartial': data.commanddetails['record'].checkinput.addresspartial,
                            'addressparentfieldname': data.commanddetails['record'].checkinput.addressparentfieldname,
                            'numberofnumbers': data.commanddetails['record'].checkinput.numberofnumbers.split(','),
                            'numberofwords': data.commanddetails['record'].checkinput.numberofwords.split(','),
                            'numberofdigits': data.commanddetails['record'].checkinput.numberofdigits.split(','),
                            'wordssubstringassertionnegation': ExportData(data.commanddetails['record'].checkinput.wordssubstring)['wordMeans'],
                            'wordssubstring': ExportData(data.commanddetails['record'].checkinput.wordssubstring)['data'],
                            'wordsstrictassertionnegation': ExportData(data.commanddetails['record'].checkinput.wordsstrict)['wordMeans'],
                            'wordsstrict': ExportData(data.commanddetails['record'].checkinput.wordsstrict)['data'],//Таблица processPreprocessInput(commandDetails['record'].checkinput.wordsstrict, commandDetails['record'].checkinput.wordsstrictassertionnegation)
                            'sql': data.commanddetails['record'].checkinput.sql,
                            'wordsclosest': data.commanddetails['record'].checkinput.wordsclosest.split(','),
                            'maxlevensteinerror': data.commanddetails['record'].checkinput.maxlevensteinerror,
                            'eval': data.commanddetails['record'].checkinput.eval,
                            'restrictanalyzefreeinputs': data.commanddetails['record'].checkinput.restrictanalyzefreeinputs.split(','),
                            'deemcorrectoninterrupt': data.commanddetails['record'].checkinput.deemcorrectoninterrupt,
                            'prioritytoalyzefreeinputs': data.commanddetails['record'].checkinput.prioritytoalyzefreeinputs.split(','),
                        }
                    }
                })
            }
        }
        else if (data.command === "transfer") {
            return {
                ...data,
                commanddetails: JSON.stringify({
                    transfer: {
                        'transfer': data.commanddetails.transfer.transfer,
                    },
                })
            }
        }
        else if (data.command === "originate") {
            return {
                ...data,
                commanddetails: JSON.stringify({
                    originate: {
                        'originate_address': data.commanddetails.originate.originate_address,
                        'originate_conversationtemplate': data.commanddetails.originate.originate_conversationtemplate,
                    },
                })
            }
        }
        else if (data.command === "bridge") {
            return {
                ...data,
                commanddetails: JSON.stringify({
                    bridge: {
                        'bridge_channel': data.commanddetails.bridge.bridge_channel,
                    },
                })
            }
        }

        else if (data.command === "setfield") {
            return {
                ...data,
                commanddetails: JSON.stringify({
                    setfield: {
                        'fieldname': data.commanddetails.setfield.fieldname,
                        'fieldvalue': data.commanddetails.setfield.fieldvalue,
                        'fieldcorrect': data.commanddetails.setfield.fieldcorrect,
                    }
                })
            }
        }

        else if (data.command === "setaiprompt") {
            return {
                ...data,
                commanddetails: JSON.stringify({
                    setaiprompt: {
                        'setaiprompt_name': data.commanddetails.setaiprompt.setaiprompt_name,
                        'setaiprompt_aimodel': data.commanddetails.setaiprompt.setaiprompt_aimodel,
                        'setaiprompt_aiprompt': data.commanddetails.setaiprompt.setaiprompt_aiprompt,
                        'setaiprompt_prompt': data.commanddetails.setaiprompt.setaiprompt_prompt,
                        'setaiprompt_tools': data.commanddetails.setaiprompt.setaiprompt_tools.split('\n'),
                    }
                })
            }
        }

        else if (data.command === "goto") {
            return {
                ...data,
                commanddetails: JSON.stringify({
                    goto: {
                        'gotoconversationtemplate': data.commanddetails.goto.gotoconversationtemplate,
                        'gotorecordnumber': data.commanddetails.goto.gotorecordnumber,
                    }
                })
            }
        }

        else if (data.command === "eval") {
            return {
                ...data,
                commanddetails: JSON.stringify({
                    eval: {
                        'eval': data.commanddetails.eval.eval
                    }
                })
            }
        }

        else if (data.command === "cardpaymenthelper") {
            return {
                ...data,
                commanddetails: JSON.stringify({
                    cardpaymenthelper: {
                        'skipifrelatedfieldscorrect': data.commanddetails.cardpaymenthelper.skipifrelatedfieldscorrect,
                    }
                })
            }
        }

        else if (data.command === "obtainnecessarydigits") {
            return {
                ...data,
                commanddetails: JSON.stringify({
                    obtainnecessarydigits: {
                        'silence': data.commanddetails.obtainnecessarydigits.silence,
                        'maxduration': data.commanddetails.obtainnecessarydigits.maxduration,
                        'skipifrelatedfieldscorrect': data.commanddetails.obtainnecessarydigits.skipifrelatedfieldscorrect,
                    },
                })
            }
        }

        else if (data.command === "findnearestoffice") {
            return {
                ...data,
                commanddetails: JSON.stringify({
                    findnearestoffice: {
                        'addressfieldname': data.commanddetails.findnearestoffice.addressfieldname,
                    }
                })
            }
        }

        else if (data.command === "sms") {
            return {
                ...data,
                commanddetails: JSON.stringify({
                    sms: {
                        'smstext': data.commanddetails.sms.smstext,
                        'transliterate': data.commanddetails.sms.transliterate,
                    }
                })
            }
        }

        else if (data.command === "preparesynthesizedspeech") {
            return {
                ...data,
                commanddetails: JSON.stringify([])
            }
        }

        else if (data.command === "logiccheck") {
            return {
                ...data,
                commanddetails: JSON.stringify({
                    logiccheck: {
                        'dirtyfields': parseRelatedFields(data.commanddetails.logiccheck.dirtyfields),
                        'fieldname1': data.commanddetails.logiccheck.fieldname1,
                        'fieldvalue1': data.commanddetails.logiccheck.fieldvalue1,
                        'fieldcorrect1': data.commanddetails.logiccheck.fieldcorrect1,
                        'fieldname2': data.commanddetails.logiccheck.fieldname2,
                        'fieldvalue2': data.commanddetails.logiccheck.fieldvalue2,
                        'fieldcorrect2': data.commanddetails.logiccheck.fieldcorrect2,
                        'fieldname3': data.commanddetails.logiccheck.fieldname3,
                        'fieldvalue3': data.commanddetails.logiccheck.fieldvalue3,
                        'fieldcorrect3': data.commanddetails.logiccheck.fieldcorrect3,
                    }
                })
            }
        }

        else if (data.command === "end") {
            return {
                ...data,
                commanddetails: JSON.stringify([])
            }
        }


        else return {}
    }
}




